import { getApi, postApi, putApi } from 'common/services/api';

class LOIService {
    // List LOIs
    async listLOIs(params = {}) {
        const queryString = new URLSearchParams(params).toString();
        return await getApi(`api/recruitment/loi${queryString ? `?${queryString}` : ''}`);
    }

    // Create LOI
    async createLOI(data) {
        return await postApi('api/recruitment/loi', data);
    }

    // Get LOI by application ID
    async getLOI(applicationId) {
        return await getApi(`api/recruitment/loi/${applicationId}`);
    }

    // Update LOI
    async updateLOI(loiId, data) {
        return await putApi(`api/recruitment/loi/${loiId}`, data);
    }

    // Send LOI email
    async sendLOI(loiId) {
        return await postApi(`api/recruitment/loi/${loiId}/send`);
    }

    // Withdraw LOI
    async withdrawLOI(loiId) {
        return await postApi(`api/recruitment/loi/${loiId}/withdraw`);
    }

    // Track LOI view (public endpoint)
    async trackLOIView(loiId, token) {
        return await getApi(`api/recruitment/loi/${loiId}/track/${token}`);
    }

    // Respond to LOI (public endpoint)
    async respondToLOI(loiId, token, data) {
        return await postApi(`api/recruitment/loi/${loiId}/respond/${token}`, data);
    }
}

export default new LOIService();

